import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import go_icon from '@/assets/images/login/go_icon.png';
import './connectModal.less';
import ProjFn from '@/utils/fn';

interface prpsJson {
  connectModelShow: boolean;
  setConnectModelShow: (val: boolean) => void;
}

function ConnectModal(prop: prpsJson) {
  const { connectModelShow, setConnectModelShow } = prop;
  const [kfShow, setKfShow] = useState<Boolean>(false);
  useEffect(() => {
    setKfShow(Number(sessionStorage.getItem('NETWORK_RETRY')) > 3);
  }, []);

  function setRetryTimes() {
    let times = 1;
    if (sessionStorage.getItem('NETWORK_RETRY')) {
      times = Number(sessionStorage.getItem('NETWORK_RETRY'));
    }
    times += 1;
    sessionStorage.setItem('NETWORK_RETRY', times.toString());
    window.location.reload();
  }

  function goLandpage() {
    ProjFn.openExternalBrower('https://www.996box.com/?customer_service_show=1');
  }

  function closeWindow() {
    setConnectModelShow(false);
    sessionStorage.setItem('NETWORK_RETRY', '1');
  }

  return (
    <Modal
      wrapClassName="connectModal-box"
      visible={connectModelShow}
      width={500}
      zIndex={999999999}
      maskClosable={true}
      centered
      footer={null}
      onCancel={() => closeWindow()}
      closeIcon={<span className="operation_close"></span>}
    >
      <div className="login_header_box">
        <div className="connectModal-box_box">
          <div className="connectModal-box_title">提示</div>
        </div>
        <div className="connectModal-box_content">
          <p className="connectModal-box_hint">
            非常抱歉，暂时无法正常连接盒子； <br />
            <br />
            辛苦您检查下网络环境，可尝试切换网络、重新连接网络或重启路由器，再点击下方“重新连接”3次处理该情况，若仍未得到解决，会提供联系客服方式，您可联系客服提交信息核实，我们会竭尽全力配合解决，不便之处敬请见谅。
          </p>
          <div className="connectModal-box_btnBox">
            <p onClick={setRetryTimes}>
              <span>
                重新连接 <img src={go_icon} alt="" />
              </span>
            </p>
          </div>
          {kfShow ? (
            <div className="connectModal-box_btnBox">
              <p onClick={goLandpage}>
                <span>
                  联系客服 <img src={go_icon} alt="" />
                </span>
              </p>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    </Modal>
  );
}

export default ConnectModal;
